import { Injectable } from "@angular/core";

@Injectable()
export class GlobalService {
    public menuItem: string;
}